import { render } from "./TownHall.vue?vue&type=template&id=69d545df"
import script from "./TownHall.vue?vue&type=script&lang=js"
export * from "./TownHall.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/TownHall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "69d545df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('69d545df', __exports__)) {
    api.reload('69d545df', __exports__)
  }
  
  module.hot.accept("./TownHall.vue?vue&type=template&id=69d545df", () => {
    api.rerender('69d545df', render)
  })

}


export default __exports__